import { render, staticRenderFns } from "./auth.vue?vue&type=template&id=6a544aa4&"
import script from "./auth.vue?vue&type=script&lang=ts&"
export * from "./auth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports